import { z } from 'zod';
import {
  CampaignGoodsSlotSchema,
  RegisteredContentSchema,
  SeedingContentChannelSchema,
  SeedingFulfillmentStatusSchema,
  SeedingParticipationStatusSchema,
} from './get-seeding-me-recruitment.dto';

/** 4탭 분류 (PENDING=제안, CONFIRMED=수락, COMPLETED=완료, REJECTED=거절) */
export const SeedingProposalStatusSchema = z.enum([
  'PENDING',
  'CONFIRMED',
  'COMPLETED',
  'REJECTED',
]);
export type SeedingProposalStatus = z.infer<typeof SeedingProposalStatusSchema>;

export const GetSeedingMeProposalServiceRequestSchema = z
  .object({
    searchStatus: SeedingProposalStatusSchema,
    page: z.number().min(1).optional(),
    size: z.number().min(1).max(100).optional(),
  })
  .describe('GetSeedingMeProposalServiceRequestSchema');

export type GetSeedingMeProposalServiceRequest = z.infer<
  typeof GetSeedingMeProposalServiceRequestSchema
>;

const SeedingProposalItemSchema = z
  .object({
    participationId: z.number(),
    campaignId: z.number(),
    searchStatus: SeedingProposalStatusSchema,
    participationStatus: SeedingParticipationStatusSchema,
    goodsImage: z.string(),
    brandName: z.string(),
    // 이벤트 로그 brand_id / campaign_title 용 (BE 0625 응답 제공).
    brandId: z.string(),
    title: z.string(),
    goodsName: z.string(),
    goodsPrice: z.number(),
    snsChannels: z.array(SeedingContentChannelSchema),
    timerEndsAt: z.string().nullable(),
    fulfillmentStatus: SeedingFulfillmentStatusSchema.nullable(),
    responseDeadlineAt: z.string().nullable(),
    rejectionReasons: z.array(z.string()).nullable(),
    messageToBrand: z.string().nullable(),
    createdAt: z.string(),
    /** 콘텐츠 등록 이력 — COMPLETED 만 채움, 그 외 빈 배열 */
    registeredContents: z.array(RegisteredContentSchema),
    /** 시딩 상품 슬롯 — "외 N개" = length - 1 */
    goodsSlots: z.array(CampaignGoodsSlotSchema),
  })
  .describe('SeedingProposalItemSchema');

export type SeedingProposalItem = z.infer<typeof SeedingProposalItemSchema>;

export const GetSeedingMeProposalServiceResponseSchema = z
  .object({
    list: z.array(SeedingProposalItemSchema),
    pagination: z.object({
      hasNext: z.boolean(),
      nextPage: z.number().nullable(),
      total: z.number(),
    }),
  })
  .describe('GetSeedingMeProposalServiceResponseSchema');

export type GetSeedingMeProposalServiceResponse = z.infer<
  typeof GetSeedingMeProposalServiceResponseSchema
>;
